import React from 'react'
import { Button, TextField } from '@shopify/polaris'

const BalanceEditForm = ({ balance, editingBalance, onSave, onCancel, onBalanceChange }) => {
	return (
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-evenly'
		}}>
			<TextField
				type='number'
				value={balance}
				onChange={onBalanceChange}
			/>
			<div style={{
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end'
			}}>
				<Button
					variant='primary'
					loading={editingBalance}
					onClick={onSave}
				>
					Save
				</Button>
				<Button
					disabled={editingBalance}
					onClick={onCancel}
				>
					Cancel
				</Button>
			</div>
		</div>
	)
}

export default BalanceEditForm

